import { graphql, useStaticQuery } from 'gatsby'

import { PointsRedemptionPageSectionData } from '../local_modules/types/PointsRedemption'

const useCmsPointsRedemption = () => {
  const data = useStaticQuery(graphql`
    query CmsPointsRedemptionLpQuery {
      cmsPointsRedemptionLp {
        sections {
          data
        }
      }
    }
  `)

  const pointsRedemptionPageLp: PointsRedemptionPageSectionData | undefined =
    data?.cmsPointsRedemptionLp?.sections?.[0]?.data

  return { pointsRedemptionPageLp }
}

export default useCmsPointsRedemption
